var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.532.257c-.336.342-.336.77-.084 1.113l.084.086 3.612 3.682H.84c-.504 0-.84.342-.84.856 0 .428.336.77.756.856h8.388l-3.612 3.682c-.336.343-.336.771-.084 1.114l.084.085c.336.343.756.343 1.092.086l.084-.086 5.04-5.138.084-.085.084-.086.084-.085v-.685l-.084-.086-.084-.086-.084-.085L6.708.257a.801.801 0 0 0-1.176 0z"
  })));
};
export default SvgArrowRight;